import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { PieChart, Pie, Cell } from "recharts";

const renderCustomizedLabel =
    ({
         cx,
         cy,
         midAngle,
         innerRadius,
         outerRadius,
         // percent,
         // index,
         value
    }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text
            x={x}
            y={y}
            fill="white"
            textAnchor={x > cx ? "start" : "end"}
            dominantBaseline="central"
        >
            {/*
            {`${(percent * 100).toFixed(0)}%`}
            */}
            {value}
        </text>
    );
};

class MainChart extends PureComponent {
    render() {
        const {
            data,
            isChecked,
            showActions,
            colors
        } = this.props;

        return (
            <div className="row">
                <div className="col-12 col-sm-5 text-right">
                    <PieChart
                        width={120}
                        height={120}
                        style={{
                            width: "100% !important",
                            height: "100% !important",
                        }}
                    >
                        <Pie
                            data={data}
                            cx={45}
                            cy={45}
                            labelLine={false}
                            label={renderCustomizedLabel}
                            outerRadius={50}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {data.map((entry, index) =>
                                <Cell
                                    key={`cell-${index}`}
                                    fill={colors[index % colors.length]}
                                />)}
                        </Pie>
                    </PieChart>
                </div>

                <div className="col-12 col-sm-7">
                    <div className="h-100 d-flex flex-column">
                        <div className="d-flex flex-column justify-content-center mt-4">
                            {data.map((value, index) => (
                                <div className="mb-2" key={index}>
                                    <div
                                        className="name-color"
                                        style={{
                                            width: 30,
                                            height: 18,
                                            float: "left",
                                            marginRight: 5,
                                            backgroundColor: colors[index % colors.length]
                                        }}
                                    /> {value.name}
                                </div>
                            ))}
                        </div>
                        {showActions ?
                        <div className="mb-4">
                            <div className="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="displayCompletionChartToClient"
                                    onChange={() => this.props.onChange(!isChecked)}
                                    checked={isChecked}
                                />
                                <label
                                    className="custom-control-label"
                                    htmlFor="displayCompletionChartToClient"
                                >
                                    Display Completion Chart to Client
                                </label>
                            </div>
                        </div>
                        : null}
                    </div>
                </div>
            </div>
        );
    }
}

MainChart.defaultProps = {
    showActions: true,
    isChecked: false,
    data: [
        { name: "Incomplete", value: 400 },
        { name: "Complete", value: 300 },
    ],
    colors: ["#0088FE", "#FF8042"]
};

MainChart.propTypes = {
    onChange: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    isChecked: PropTypes.bool,
    data: PropTypes.array.isRequired,
    showActions: PropTypes.bool.isRequired,
    colors: PropTypes.array.isRequired
};

export default MainChart;
